<div class="flex-row column">
    <h3 class="fs-16 fw-7 text-dark mb-25">Risk Profiling</h3>
    <p class="fs-14 text-dark">Your risk profiling is pending. Do you want to
        complete it now</p>
    <div class="mt-25 flex-row content-between">
        <button type="button" class="btn btn-primary fs-md-13" (click)="showRiskProfile()">Start Risk
            Profiling</button>
        <button type="button" class="btn btn-outline fs-md-13" (click)="closeDialog()">Cancel</button>
    </div>
</div>